import React from 'react';
import { Dropdown, Icon } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { datasetMarkdownUrl } from '@/constants/urls';
import DownloadAction from '@/components/ribbon-actions/DownloadAction';
import Events from '../hooks/events';
import catalogueEvents from '../catalogue/hooks/events';
import dictionaryEvents from '../dictionaries/hooks/events';

const DownloadDatasetActionMenu = ({ code, disabled }) => {
  const downloadAll = Events.useDownloadDataset({ code });
  const downloadCatalogue = catalogueEvents.useDownloadDatasetCatalogue({ code });
  const downloadDictionaries = dictionaryEvents.useDownloadDictionaries({ code });

  return (
    <Dropdown
      icon={null}
      trigger={(<DownloadAction name="metadata" />)}
      className="aridhia-metadata-dataset-action-menu"
      disabled={disabled}
    >
      <Dropdown.Menu>
        <Dropdown.Item as="a" selected={false} href={datasetMarkdownUrl({ code }, '#')}>
          <Icon name="file alternate outline" />
          <FormattedMessage id="actions.metadata.markdown" />
        </Dropdown.Item>
        <Dropdown.Item as="a" selected={false} onClick={downloadAll}>
          <Icon name="file alternate outline" />
          <FormattedMessage id="actions.metadata.dataset" />
        </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item as="a" selected={false} onClick={downloadCatalogue}>
          <Icon name="file alternate outline" />
          <FormattedMessage id="actions.metadata.catalogue" />
        </Dropdown.Item>
        <Dropdown.Item as="a" selected={false} onClick={downloadDictionaries}>
          <Icon name="file alternate outline" />
          <FormattedMessage id="actions.metadata.dictionary" />
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default DownloadDatasetActionMenu;
